import React, { Suspense } from 'react';

const MicrofrontendReactWrapper = React.lazy(() => import('./MicrofrontendReactWrapper'));

export const MicrofrontendPrototype = (): JSX.Element => {
  return (
    <Suspense fallback="Loading...">
      <MicrofrontendReactWrapper />
    </Suspense>
  );
};
